module.exports = __webpack_public_path__ + "src/app/_content/imgs/Cosy/mini-cosySec.png?bd5bc296797774e22b44bb4970bc5bd8";